import { AppRouter } from 'common/types/globalTypes';

export interface SettingsOption {
  name: string;
  icon?: string;
  path?: string;
  component?: React.FC;
  routeName?: AppRouter;
  children?: SettingsOption[];
}
export function filterSectionsByPrivilege(
  sections: SettingsOption[],
  privileges: Set<string>
): SettingsOption[] {
  return sections
    .map((section) => {
      // If it has children, filter them recursively
      if (section.children) {
        const filteredChildren = filterSectionsByPrivilege(
          section.children,
          privileges
        );

        if (filteredChildren.length > 0) {
          return { ...section, children: filteredChildren };
        }

        return null; // Remove parent if no allowed children
      }

      // Keep if route allowed OR no routeName (non restricted menu)
      return privileges.has(section.routeName!) ||
        section.routeName === undefined
        ? section
        : null;
    })
    .filter(Boolean) as SettingsOption[];
}
